import { useState, useEffect } from "react";
import { Button } from "../ui/button";
import {
  Sheet, SheetContent, SheetTrigger,
} from "../ui/sheet";
import { Menu } from "lucide-react";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "Our Work", href: "#work" },
  { label: "Clients", href: "#clients" },
  { label: "Why Us", href: "#why" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/90 backdrop-blur-xl border-b border-zinc-200" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between h-20">
        <a href="#top" data-testid="header-logo" className="flex items-center gap-3" onClick={(e) => { e.preventDefault(); go("#top"); }}>
      <img src="/logo.png" alt="Pooja Painting Works" className="h-9 sm:h-11 w-auto" />
          <div className="leading-none block">
            <div className="font-display font-extrabold text-sm sm:text-lg tracking-tight">
              <span style={{ color: "#5CB531" }}>POOJA</span>{" "}
              <span style={{ color: "#E0A100" }}>PAINTING WORKS</span>
            </div>
            <div className={`overline text-[9px] sm:text-[10px] ${scrolled ? "text-accent" : "text-amber-400"}`}>
              Est. 2013
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <button
              key={n.href}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              onClick={() => go(n.href)}
              className={`text-sm font-semibold transition-colors hover:text-accent ${scrolled ? "text-zinc-700" : "text-white/90"}`}
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          
          <Button data-testid="header-quote-btn" onClick={() => go("#contact")}
            className="rounded-none bg-accent hover:bg-accent/90 text-white font-semibold hidden sm:inline-flex">
            Request Quote
          </Button>
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" data-testid="mobile-menu-btn"
                className={`lg:hidden rounded-none ${scrolled ? "text-zinc-900" : "text-white hover:text-white hover:bg-white/10"}`}>
                <Menu className="w-6 h-6" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-72" data-testid="mobile-menu-content">
              <div className="flex flex-col gap-2 mt-10">
                {NAV.map((n) => (
                  <button key={n.href} data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                    onClick={() => go(n.href)}
                    className="text-left text-lg font-semibold text-zinc-800 py-3 border-b border-zinc-100 hover:text-accent">
                    {n.label}
                  </button>
                ))}
                <Button data-testid="mobile-quote-btn" onClick={() => go("#contact")}
                  className="rounded-none bg-accent hover:bg-accent/90 text-white mt-4 h-12">
                  Request Quote
                </Button>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};
